module.exports = __webpack_public_path__ + "static/media/dashboardlogo (3).857b4bcc.png";